////////////////////////////////////////////////////////////
//
//      Main Application Entry Point — Vue SPA
//
////////////////////////////////////////////////////////////

// Tailwind v4 — processed by @tailwindcss/vite
import './styles/tailwind.css';

// Direction-aware route transitions — must load eagerly because App.vue,
// EmployerLayout, and MyJobsLayout all reference these classes via
// <transition :name="page-{fwd,back,sib}">.
import './styles/route-transitions.css';

// Design tokens (must load first so subsequent pages resolve var(--jb-*))
import '../css/_tokens.css';

// Global stylesheet — navbar/footer/shared chrome rendered outside the SPA.
// Page-level sheets (jobs/jobdetail/postjob/employer.css) are imported by
// their route components so Vite code-splits them out of the render-blocking
// app.css (was 205KB; ~80% of it belonged to routes the visitor never opens).
import '../css/site.css';

import { createPinia } from 'pinia';
import { createJobsApp } from './lib/create-app.js';
import App from './App.vue';
import router from './router';

// Pages served by external Identity system (ScholaroWeb SSO) render their
// own server-side content inside #app. Don't mount the Vue SPA on those
// pages or it will obliterate the login/register forms.
const identityPrefixes = ['/Login', '/Identity'];
const isIdentityPage = identityPrefixes.some(p =>
    window.location.pathname.startsWith(p)
);

if (!isIdentityPage) {
    const app = createJobsApp(App);
    app.use(createPinia());
    app.use(router);
    app.mount('#app');
}
